import { getBrandHref } from '@/_lib/brand-href';
import { FEATURED_BRANDS } from '@/_utils/Constants';

export type CatalogBreadcrumbItem = { title: string; link?: string };

type CatalogCategory = {
  title: string;
  slug: string;
};

type BuildCatalogBreadcrumbsParams = {
  homeLabel: string;
  brand: { name: string; id: string };
  category?: CatalogCategory | null;
  productTitle?: string | null;
};

/**
 * Home → Restaurants → Brand → Category? → Product?
 * Last item has no link.
 */
export function buildCatalogBreadcrumbs({
  homeLabel,
  brand,
  category,
  productTitle,
}: BuildCatalogBreadcrumbsParams): CatalogBreadcrumbItem[] {
  const items: CatalogBreadcrumbItem[] = [{ title: homeLabel, link: '/' }];

  const brandHref = getBrandHref(brand.id);
  const hasCategory = Boolean(category?.title && category?.slug);
  const hasProduct = Boolean(productTitle);

  if (!hasCategory && !hasProduct) {
    items.push({ title: brand.name });
    return items;
  }

  items.push({ title: brand.name, link: brandHref });

  if (hasCategory && hasProduct && category) {
    items.push({
      title: category.title,
      link: getBrandHref(brand.id, { hash: category.slug }),
    });
    items.push({ title: productTitle! });
    return items;
  }

  if (hasCategory && category) {
    items.push({ title: category.title });
    return items;
  }

  items.push({ title: productTitle! });
  return items;
}
